<template>
  <v-app id="app">
    <router-view />
    <Alert></Alert>
  </v-app>
</template>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<script>
import Alert from "@/components/common/Alert.vue";

export default {
  components: {
    Alert,
  },
  created: function() {
    // appCode에 따라 문서 제목 설정
    document.title = "SHOP+ 정품인증서비스";
    this.appTitle = document.title; // 앱 제목도 함께 업데이트
  },
};
</script>
